module.exports = __webpack_public_path__ + "static/Femaleworker2-6e77498664865388f80d0666058f3212.png";